import { RouterElement, ROUTER_ELEMENTS } from '../routing/index';

export const getCurrentRoute = (
  location: string
): RouterElement | undefined => {
  const result = ROUTER_ELEMENTS.find((element) => element.url === location);

  return result;
};
